
import { useScrollAnimation, useStaggeredAnimation } from "@/hooks/useScrollAnimation";

const BuyerLandingHowItWorks = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation<HTMLElement>();
  const { ref: stepsRef, visibleItems } = useStaggeredAnimation<HTMLDivElement>(3, 200);

  const steps = [
    {
      number: 1,
      title: "Set Your Preferences",
      description: "Tell us your investment criteria: markets, price range, property types, and purchasing method."
    },
    {
      number: 2,
      title: "Discover Properties",
      description: "Browse curated investment opportunities that match your criteria. See properties on map or in list view."
    },
    {
      number: 3,
      title: "Connect & Close",
      description: "Message sellers directly, ask questions, and move fast on deals. No platform fees on transactions."
    }
  ];

  return (
    <section id="how-it-works" ref={sectionRef} className="py-16 px-4">
      <div className="container mx-auto max-w-4xl">
        <h2 className={`text-3xl font-bold text-center mb-12 transition-all duration-700 ${isVisible ? 'animate-fade-in-up' : 'opacity-0 translate-y-8'}`}>
          How It Works
        </h2>
        <div ref={stepsRef} className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={step.number}
              className={`text-center transition-all duration-500 ${
                visibleItems.includes(index) ? 'animate-scale-in' : 'opacity-0 scale-95'
              }`}
            >
              <div className="w-16 h-16 bg-[#ffd700] rounded-full flex items-center justify-center mx-auto mb-4 hover-lift hover:animate-bounce-gentle">
                <span className="text-2xl font-bold text-[#080c14]">{step.number}</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
              <p className="text-gray-300">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuyerLandingHowItWorks;
